export const extras = {
  sources: {
  },
  layers: []
};

export const baseGraphs = {
  sources: {
    'basic_pedestrian': {
      id: 'basic_pedestrian',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://www.herault-mobility.fr/layers/herault.basic_pedestrian/{z}/{x}/{y}.pbf'
      ],
      attribution: '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    },
    'cnig_wheelchair_user' : {
      id: 'cnig_wheelchair_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://www.herault-mobility.fr/layers/herault.cnig_wheelchair_user/{z}/{x}/{y}.pbf'
      ],
      attribution: "© <a target='_blank' href='https://www.atipy.fr/'> Atipy</a>"
    },
    'cnig_visually_impaired_user': {
      id: 'cnig_visually_impaired_user',
      type: 'vector',
      maxzoom: 15,
      tiles: [
        'https://www.herault-mobility.fr/layers/herault.cnig_visually_impaired_user/{z}/{x}/{y}.pbf'
      ],
      attribution: "© <a target='_blank' href='https://www.atipy.fr/'> Atipy</a>"
    }
  },
  layers: [
    {
      'id': 'basic_pedestrian',
      'source': 'basic_pedestrian',
      'source-layer': 'herault.basic_pedestrian',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-cap': 'round',
        'line-join': 'round'
      },
      'paint': {
        'line-color': '#6ba328',
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10, 0.5,
          20, 4
        ]
      }
    },
    {
      'id': 'cnig_wheelchair_user',
      'source': 'cnig_wheelchair_user',
      'source-layer': 'herault.cnig_wheelchair_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', -1, ['number', ['get', 'acc']], 4],
        'line-cap': 'round',
        'line-join': 'round'
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 0], '#6ba328',
          ['==', ['get', 'acc'], 1], '#d4901e',
          ['==', ['get', 'acc'], 2], '#f00025',
          ['==', ['get', 'acc'], 3], '#b3afaf',
          '#b3afaf'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    },
    {
      'id': 'cnig_visually_impaired_user',
      'source': 'cnig_visually_impaired_user',
      'source-layer': 'herault.cnig_visually_impaired_user',
      'type': 'line',
      'minzoom': 6,
      'layout': {
        'visibility': 'none',
        'line-sort-key': ['*', -1, ['number', ['get', 'acc']], 4],
        'line-cap': 'round',
        'line-join': 'round'
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'acc'], 0], '#6ba328',
          ['==', ['get', 'acc'], 1], '#d4901e',
          ['==', ['get', 'acc'], 2], '#f00025',
          ['==', ['get', 'acc'], 3], '#b3afaf',
          '#b3afaf'
        ],
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          ['case', 
            ['==', ['get', 'acc'], 0], 1,
            ['==', ['get', 'acc'], 1], 1,
            ['==', ['get', 'acc'], 2], 1, 
            0
          ],
          20,
          ['case',
            ['==', ['get', 'acc'], 0], 6,
            ['==', ['get', 'acc'], 1], 6,
            ['==', ['get', 'acc'], 2], 6,
            4
          ]
        ]
      }
    }
  ]
};



export const baseMaps = {
  version: 8,
  glyphs: 'https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=k20fNAVQobo9djwCJvVl',
  sources: {
    'osm-tiles': {
      type: 'raster',
      tiles: [
        'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
      ],
      tileSize: 256,
      maxzoom: 19,
      attribution: '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    },
    'ortho-tiles': {
      type: 'raster',
      tiles: [
        'https://api.maptiler.com/maps/3684748f-10e1-4315-8a0a-8954d88a70c0/{z}/{x}/{y}.png?key=k20fNAVQobo9djwCJvVl'
      ],
      tileSize: 256,
      maxzoom: 19,
      attribution: '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    },
    ...baseGraphs.sources,
    ...extras.sources
  },
  layers: [
    {
      id: 'osm-tiles',
      type: 'raster',
      source: 'osm-tiles',
      interactive: true
    }, 
    {
      id: 'ortho-tiles',
      type: 'raster',
      source: 'ortho-tiles',
      interactive: true,
      layout: {
      // Make the layer not visible by default.
        'visibility': 'none'
      },
    },
    ...baseGraphs.layers,
    ...extras.layers]
};